import React, { Component } from 'react';
import PropTypes from 'prop-types';
import findIndex from 'lodash/findIndex';
import { translate } from 'react-i18next';

import { Button, ButtonGroup } from '../../buttonpanel';
import css from '../../../styles/front/overview';

class OverviewHeader extends Component {
    static propTypes = {
        markets: PropTypes.array.isRequired,
        ranks: PropTypes.array.isRequired,
        selectedMarket: PropTypes.object.isRequired,
        selectedRank: PropTypes.string.isRequired,
        changeMarket: PropTypes.func.isRequired,
        changeRank: PropTypes.func.isRequired,
        t: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        this.state = { open: false };

        this._onChange = e => {
            const { value } = e.target;
            const { changeMarket, markets } = this.props;

            const currentIndex = findIndex(markets, o => o.id === value);

            if (currentIndex > -1) {
                changeMarket(markets[currentIndex]);
            }
        };
    }

    renderMarketSelector() {
        const t = this.props.t;

        // Filter out the markets that have all type of source data
        const maxNumOfSources = this.props.markets.map((market) =>
            market.sources.length
        ).reduce((a, b) => Math.max(a, b));

        const markets = this.props.markets.filter((market) =>
            market.sources.length === maxNumOfSources
        );

        return (
            <div className={css.titleContainer}>
                <div className={ css.title }>
                    <h3 className={ css.subtitle }>{t('menu:overview')}</h3>
                    <div className={css.selectWrapper}>
                        <select
                            className={css.select}
                            ref={node => {this.select = node;}}
                            onChange={this._onChange}
                        >
                            {markets.map(market => (
                                <option key={market.id} value={market.id}>
                                    {market.name}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
        );
    }

    renderRankButtons() {
        const { changeRank, ranks, selectedRank, t } = this.props;

        return (
            <ButtonGroup direction="inline">
                {ranks.map((rank, i) => {
                    if (rank.id === selectedRank) {
                        return (
                            <Button
                                key={i}
                                type="tab"
                                label={t(rank.label)}
                                onClick={changeRank(rank.id)}
                                metaTitle={['front:overview:', rank.label].join('')}
                            />
                        );
                    }

                    return (
                        <Button
                            key={i}
                            type="transparent"
                            label={t(rank.label)}
                            onClick={changeRank(rank.id)}
                            metaTitle={['front:overview:', rank.label].join('')}
                        />
                    );
                })}
            </ButtonGroup>
        );
    }

    render() {
        return (
            <div className={ css.titleWrapper }>
                {this.renderMarketSelector()}
                {this.renderRankButtons()}
            </div>
        );
    }
}

export default translate('marketsOverview')(OverviewHeader);



/** WEBPACK FOOTER **
 ** /src/shared/components/front/overview/OverviewHeader.js
 **/